
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21 14.2V8.91002C21 8.02002 19.92 7.57002 19.29 8.20002L17 10.5V7.00002C17 6.45002 16.55 6.00002 16 6.00002H10.39L19.3 14.91C19.92 15.54 21 15.09 21 14.2ZM2.70998 2.56002C2.31998 2.95002 2.31998 3.58002 2.70998 3.97002L4.72998 6.00002H3.99998C3.44998 6.00002 2.99998 6.45002 2.99998 7.00002V17C2.99998 17.55 3.44998 18 3.99998 18H16C16.21 18 16.39 17.92 16.55 17.82L19.03 20.3C19.42 20.69 20.05 20.69 20.44 20.3C20.83 19.91 20.83 19.28 20.44 18.89L4.11998 2.56002C3.72998 2.17002 3.09998 2.17002 2.70998 2.56002Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-videocam-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconVideocamOff

    ```js
    <b-new-b-icon-videocam-off />
    ```
</docs>


